import { render, staticRenderFns } from "./Username.vue?vue&type=template&id=37212974&scoped=true&"
import script from "./Username.vue?vue&type=script&lang=js&"
export * from "./Username.vue?vue&type=script&lang=js&"
import style0 from "./Username.vue?vue&type=style&index=0&id=37212974&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37212974",
  null
  
)

export default component.exports